import { render, staticRenderFns } from "./lista-propietarios.vue?vue&type=template&id=75d177ba&"
import script from "./lista-propietarios.vue?vue&type=script&lang=js&"
export * from "./lista-propietarios.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports